import { useSelector } from 'react-redux';
import { getAlertSettingsSourceSetModel } from './';

export const useAlertSettingsSourceSetModel = () =>
    useSelector(getAlertSettingsSourceSetModel);
